export const ArrowLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    fill="none"
    viewBox="0 0 14 10"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M4.917 8.75 1.167 5l3.75-3.75"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M12.834 5H1.584"
    ></path>
  </svg>
);
